import React, { useState } from 'react';
import { FiAlertTriangle, FiX } from 'react-icons/fi';
import './ShutDownSocietyModal.css';

const ShutDownSocietyModal = ({ society, memberCount, onClose, onConfirm, isSubmitting, errorMessage }) => {
  const [confirmText, setConfirmText] = useState('');
  const canConfirm = confirmText === 'SHUTDOWN' && !isSubmitting;
  const otherMembers = Math.max(0, (memberCount || 1) - 1);

  return (
    <div className="sdm-overlay" onClick={onClose}>
      <div className="sdm-sheet" onClick={e => e.stopPropagation()}>
        <button className="sdm-close" onClick={onClose} disabled={isSubmitting}>
          <FiX size={20} />
        </button>

        <div className="sdm-icon-wrap">
          <FiAlertTriangle size={28} className="sdm-icon" />
        </div>

        <h2 className="sdm-title">Shut Down Society</h2>
        <p className="sdm-subtitle"><strong>{society?.name}</strong></p>

        <div className="sdm-section">
          <p className="sdm-body">
            This will archive the society. All tournaments, leaderboards, and scoring
            history will be preserved but the society will no longer be active.
          </p>
          {otherMembers > 0 && (
            <div className="sdm-member-warning">
              <strong>{otherMembers} other member{otherMembers !== 1 ? 's' : ''}</strong> will
              lose access to this society. They will see a notification the next time they
              open the app.
            </div>
          )}
          <p className="sdm-body">This action cannot be undone from within the app.</p>
        </div>

        {errorMessage && (
          <div className="sdm-error">{errorMessage}</div>
        )}

        <div className="sdm-confirm-section">
          <label className="sdm-confirm-label">
            Type <strong>SHUTDOWN</strong> to confirm
          </label>
          <input
            className="sdm-confirm-input"
            type="text"
            value={confirmText}
            onChange={e => setConfirmText(e.target.value.toUpperCase())}
            placeholder="SHUTDOWN"
            disabled={isSubmitting}
            autoCapitalize="characters"
          />
        </div>

        <div className="sdm-actions">
          <button className="sdm-btn sdm-btn--cancel" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </button>
          <button className="sdm-btn sdm-btn--confirm" onClick={onConfirm} disabled={!canConfirm}>
            {isSubmitting ? 'Shutting down…' : 'Shut Down Society'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShutDownSocietyModal;
